import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IProductOffering } from "../types/products";

const API = process.env.REACT_APP_API;

interface UpdateProductOfferingData {
  product?: number;
  fair?: number;
  price?: string;
  cost?: string;
  stock?: number;
  unlimited_stock?: boolean;
  available?: boolean;
}

const useUpdateProductOffering = () => {
  const queryClient = useQueryClient();
  const fetch = useFetch();

  return useMutation({
    mutationFn: ({
      id,
      offering,
    }: {
      id: number;
      offering: UpdateProductOfferingData;
    }) => {
      return fetch(`${API}/api/semeadora/offerings/${id}/`, {
        method: "PATCH",
        body: offering,
      }) as Promise<IProductOffering>;
    },
    onSuccess: (data) => {
      // Invalida queries relacionadas
      queryClient.invalidateQueries({ queryKey: ["product-offerings"] });
      queryClient.invalidateQueries({
        queryKey: ["product-offering", data.id],
      });
    },
    onError: (error) => {
      console.log("onError", error);
    },
  });
};

export default useUpdateProductOffering;
